import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Calendar = (props) => {
  const { height, width, stroke, className } = props;
  return (
    <svg
      id="calendar"
      width={width}
      height={height}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <path d="M18.3594 5.85938C17.5503 5.85938 16.8945 5.20356 16.8945 4.39453V1.46484C16.8945 0.655811 17.5503 0 18.3594 0C19.1684 0 19.8242 0.655811 19.8242 1.46484V4.39453C19.8242 5.20356 19.1684 5.85938 18.3594 5.85938Z" />
    <path d="M22.3145 2.92969H21.2891V4.39453C21.2891 6.00996 19.9748 7.32422 18.3594 7.32422C16.7439 7.32422 15.4297 6.00996 15.4297 4.39453V2.92969H9.57031V4.39453C9.57031 6.00996 8.25605 7.32422 6.64062 7.32422C5.0252 7.32422 3.71094 6.00996 3.71094 4.39453V2.92969H2.68555C1.20474 2.92969 0 4.13442 0 5.61523V8.88672H25V5.61523C25 4.13442 23.7953 2.92969 22.3145 2.92969Z" />
    <path d="M6.64062 5.85938C5.83159 5.85938 5.17578 5.20356 5.17578 4.39453V1.46484C5.17578 0.655811 5.83159 0 6.64062 0C7.44966 0 8.10547 0.655811 8.10547 1.46484V4.39453C8.10547 5.20356 7.44966 5.85938 6.64062 5.85938Z" />
    <path d="M0 10.1852H25V22C25 23.6569 23.6569 25 22 25H3C1.34315 25 0 23.6569 0 22V10.1852Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Calendar.defaultProps = {
  className: null,
};

Calendar.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Calendar;
